import { Action } from '@/_core/fluxstore/types';
import { CurrentWsState } from '../types';
import { useCurrentWsStore } from '../useModule';
import { WorkspaceRole } from '@/_core/utils/roles';

const { registerReducer } = useCurrentWsStore();

export class AddMember extends Action<CurrentWsState> {
    public static ACTION_TYPE = 'AddMember';
    public constructor(public role: number) {
        super(AddMember.ACTION_TYPE);
    }
}

const reducer = (state: CurrentWsState, action: AddMember): void => {
    if (action.role === WorkspaceRole.Observer) {
        state.observerCount += 1;
    } else {
        state.memberCount += 1;
    }
};

//@ts-ignore
registerReducer(AddMember.ACTION_TYPE, reducer);
